import {
    GET_FABRIC_REQUEST, GET_FABRIC_SUCCESS, GET_FABRIC_ERROR,
    ADD_FABRIC_REQUEST, ADD_FABRIC_SUCCESS, ADD_FABRIC_ERROR,
    DELETE_FABRIC_REQUEST, DELETE_FABRIC_SUCCESS, DELETE_FABRIC_ERROR,
    UPDATE_FABRIC_REQUEST, UPDATE_FABRIC_ERROR, UPDATE_FABRIC_SUCCESS,

} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_FABRIC_REQUEST:
            return {
                loading: true,
            };
        case GET_FABRIC_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_FABRIC_ERROR:
            return {
                ...state,
                loading: false
            };
        case ADD_FABRIC_REQUEST:
            return {
                loading: true,
            };
        case ADD_FABRIC_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case ADD_FABRIC_ERROR:
            return {
                ...state,
                loading: false
            };
        case DELETE_FABRIC_REQUEST:
            return {
                loading: true,
            };
        case DELETE_FABRIC_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case DELETE_FABRIC_ERROR:
            return {
                ...state,
                loading: false
            };
        case UPDATE_FABRIC_REQUEST:
            return {
                loading: true,
            };
        case UPDATE_FABRIC_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case UPDATE_FABRIC_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}